import React from 'react';
import { NavLink } from 'react-router-dom';

const PerformanceReviewsCrumb = () => (
  <NavLink to="/human-resources/performance-reviews">Performance Reviews</NavLink>
);

export default PerformanceReviewsCrumb;
